import theme, { Theme as NewTheme } from './theme';

export type Theme = NewTheme;

export default theme;
